export default "__VITE_ASSET__uQHqx9r6__"